import React from 'react'

export default ({ ...props }) => (
  <svg viewBox='0 0 409.38 62.72' {...props} style={{ width: '175px' }}>
    <path
      style={{ fill: '#0072bc' }}
      d='M67,79.39c-1,0-2.08,0-3.1-.11a1.82,1.82,0,1,1,.29-3.63c.92.07,1.87.11,2.81.11a42.65,42.65,0,0,0,15.71-3.23,28,28,0,0,1,6.07-2,1.82,1.82,0,1,1,.52,3.6A25.72,25.72,0,0,0,84,75.91,46.31,46.31,0,0,1,67,79.39'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M67,73.16a31.59,31.59,0,0,1-9.54-1.45l-.12,0c-2.14-.68-4.79-1.52-10.68.5a1.82,1.82,0,0,1-1.19-3.44c7-2.42,10.61-1.28,13-.53l.12,0A27.88,27.88,0,0,0,67,69.52a36.41,36.41,0,0,0,13.4-2.79c6.41-2.55,9.62-3.21,14.89-1.8a1.82,1.82,0,0,1-.93,3.52c-4.15-1.11-6.39-.82-12.61,1.66a40.11,40.11,0,0,1-14.75,3'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M67,66.92a24.9,24.9,0,0,1-11.06-2.53,38.55,38.55,0,0,1-7-4.55c-3.27-2.52-4-3.12-9.39-2.11a1.82,1.82,0,0,1-.67-3.58c3.34-.63,5.45-.67,7.28-.15a14.76,14.76,0,0,1,5,3c3.46,2.67,8.19,6.32,15.82,6.32a30.31,30.31,0,0,0,11.09-2.34c5.53-2.2,9.25-3.07,12.84-3s6.9,1.12,11.5,2.69a1.82,1.82,0,1,1-1.17,3.44c-8.88-3-11.88-3.73-21.82.23A34,34,0,0,1,67,66.92'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#ed1c24' }}
      d='M67,60.68c-6.75,0-11.07-3.34-14.23-5.77a27.49,27.49,0,0,0-3.36-2.36,1.82,1.82,0,1,1,1.79-3.17A31.83,31.83,0,0,1,55,52c3,2.36,6.5,5,12,5a24.15,24.15,0,0,0,8.79-1.9c13.81-5.5,19.57-3.52,30,.07l.14,0,1.94.66a1.82,1.82,0,0,1-1.17,3.45l-2-.67-.14-.05c-10.25-3.52-14.93-5.13-27.49-.13A27.5,27.5,0,0,1,67,60.68'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M67.39,42.1a1.82,1.82,0,0,1-.61-3.53l1-.39,1-.43c9.18-3.65,17-5.13,24.57-4.65a46.94,46.94,0,0,1,5.56.7,1.82,1.82,0,0,1-.66,3.58,41.84,41.84,0,0,0-5.13-.65c-7-.44-14.33,1-23,4.4l-1,.42c-.57.23-.89.36-1.15.45a1.76,1.76,0,0,1-.6.1'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M67.09,48.25c-2.47,0-4.17-1.22-6.73-3.23l-.23-.17c-4.16-3.26-8.87-7-19.12-6.61a1.82,1.82,0,1,1-.12-3.63,30.59,30.59,0,0,1,13.46,2.27,35.66,35.66,0,0,1,8,5.1l.22.18c1.74,1.36,2.77,2.14,3.79,2.36s2.43,0,4.76-1c7.87-3.13,14.47-4.49,20.78-4.28,5.87.2,10.88,1.76,15.92,3.47a1.82,1.82,0,1,1-1.17,3.44c-10.53-3.57-18.6-5.45-34.19.75a15.1,15.1,0,0,1-5.4,1.32'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M67,54.45c-4.65,0-7.58-2.27-10.44-4.48-4.17-3.22-8.48-6.55-19.33-4.5a1.82,1.82,0,1,1-.68-3.58c12.46-2.35,17.88,1.84,22.23,5.2,4,3.1,6.92,5.34,14.67,2.25,7.47-3,13.34-4.14,19-3.79,5.26.31,9.91,1.91,15.29,3.76l2.07.71a1.82,1.82,0,0,1-1.17,3.44l-2.08-.71c-10.66-3.67-17.1-5.88-31.81,0A21.35,21.35,0,0,1,67,54.45'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M53,33.84a1.88,1.88,0,0,1-.57-.09,29.37,29.37,0,0,0-7.74-1.47,1.82,1.82,0,0,1,.14-3.64,32.8,32.8,0,0,1,8.75,1.66A1.82,1.82,0,0,1,53,33.84'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M159.37,39.55a2.39,2.39,0,0,1-.5,1.32l-2.06,2.8a2,2,0,0,1-1.79.87,2.28,2.28,0,0,1-2.2-2.11,2,2,0,0,1,.55-1.37l2.16-2.79a2,2,0,0,1,1.74-.88,2,2,0,0,1,2.1,2.16m-7,10a2.75,2.75,0,1,1,5.49,0V67.71a2.75,2.75,0,1,1-5.49,0Z'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M175.13,70.64a14.93,14.93,0,0,1-9-2.56,2.89,2.89,0,0,1-1.46-2.29A2.32,2.32,0,0,1,167,63.5a3.15,3.15,0,0,1,1.83.64,10.29,10.29,0,0,0,6.18,2c2.71,0,4.49-.87,4.49-2.51s-2.19-2.2-4-2.62c-8.19-1.83-10.3-3.7-10.3-7.64,0-4.26,3.62-6.73,10.26-6.73a15.59,15.59,0,0,1,7,1.6,2.6,2.6,0,0,1,1.78,2.43,2.09,2.09,0,0,1-2.2,2.06,3.43,3.43,0,0,1-1.55-.37,11.83,11.83,0,0,0-4.95-1.24c-3.16,0-4.81.64-4.81,2.11,0,1.28,1.2,1.65,4.9,2.56,6.23,1.56,9.44,2.94,9.44,7.42s-3.85,7.42-9.89,7.42'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M206.77,65.42a2.34,2.34,0,1,1,0,4.67H194a2.75,2.75,0,0,1-2.75-2.75V49.58a2.75,2.75,0,1,1,5.5,0V65.42Z'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M221.2,60.93h6.18l-3.07-7.19Zm14.56,6A3.17,3.17,0,0,1,236,68a2.42,2.42,0,0,1-2.56,2.43,2.45,2.45,0,0,1-2.34-1.6l-1.87-3.76h-9.9l-1.87,3.76a2.45,2.45,0,0,1-2.34,1.6A2.42,2.42,0,0,1,212.59,68a3.17,3.17,0,0,1,.27-1.14L222,48.29a2.34,2.34,0,0,1,2.29-1.46,2.37,2.37,0,0,1,2.29,1.46Z'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M258.15,61.48v-12a2.62,2.62,0,0,1,5.23,0V67.85a2.53,2.53,0,0,1-2.62,2.61,2.46,2.46,0,0,1-2-.92L246.89,56.08V67.85a2.61,2.61,0,1,1-5.22,0V49.44a2.49,2.49,0,0,1,2.61-2.61,2.82,2.82,0,0,1,2.06,1Z'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M276.65,51.87V65.42h3.81c4.81,0,7.46-2.65,7.46-6.77s-2.65-6.78-7.46-6.78Zm-5.49-1.93a2.67,2.67,0,0,1,2.75-2.75h6.77c7.83,0,12.73,4.9,12.73,11.46s-4.9,11.44-12.73,11.44h-6.77a2.75,2.75,0,0,1-2.75-2.75Z'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M308.58,70.64a14.93,14.93,0,0,1-9-2.56,2.89,2.89,0,0,1-1.46-2.29,2.31,2.31,0,0,1,2.38-2.29,3.15,3.15,0,0,1,1.83.64,10.29,10.29,0,0,0,6.18,2c2.71,0,4.49-.87,4.49-2.51s-2.2-2.2-4-2.62c-8.2-1.83-10.3-3.7-10.3-7.64,0-4.26,3.61-6.73,10.26-6.73a15.63,15.63,0,0,1,7,1.6,2.6,2.6,0,0,1,1.78,2.43,2.09,2.09,0,0,1-2.2,2.06,3.43,3.43,0,0,1-1.55-.37,11.83,11.83,0,0,0-4.95-1.24c-3.16,0-4.81.64-4.81,2.11,0,1.28,1.19,1.65,4.9,2.56,6.23,1.56,9.44,2.94,9.44,7.42s-3.85,7.42-9.89,7.42'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M333.76,70.64a14.9,14.9,0,0,1-9-2.56,2.87,2.87,0,0,1-1.47-2.29,2.32,2.32,0,0,1,2.39-2.29,3.15,3.15,0,0,1,1.83.64,10.29,10.29,0,0,0,6.18,2c2.7,0,4.49-.87,4.49-2.51s-2.2-2.2-4-2.62c-8.2-1.83-10.31-3.7-10.31-7.64,0-4.26,3.62-6.73,10.26-6.73a15.64,15.64,0,0,1,7,1.6,2.6,2.6,0,0,1,1.78,2.43,2.09,2.09,0,0,1-2.2,2.06,3.37,3.37,0,0,1-1.55-.37,11.87,11.87,0,0,0-4.95-1.24c-3.16,0-4.81.64-4.81,2.11,0,1.28,1.19,1.65,4.9,2.56,6.23,1.56,9.43,2.94,9.43,7.42s-3.84,7.42-9.89,7.42'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M360.55,67.71a2.75,2.75,0,1,1-5.49,0V51.87H349a2.34,2.34,0,0,1,0-4.68h17.67a2.34,2.34,0,1,1,0,4.68h-6.09Z'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M383.64,66c4.25,0,6.95-3.16,6.95-7.32s-2.7-7.33-6.95-7.33-7,3.16-7,7.33,2.71,7.32,7,7.32m0,4.67c-7.52,0-12.46-5.13-12.46-12s4.94-12,12.46-12,12.45,5.12,12.45,12-4.94,12-12.45,12'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M407.77,67.71a2.75,2.75,0,0,1-5.5,0V49.94A2.76,2.76,0,0,1,405,47.19h13.69a2.34,2.34,0,1,1,0,4.68H407.77v4.25h6.37a2.34,2.34,0,0,1,0,4.68h-6.37Z'
      transform='translate(-35.07 -22.66)'
    />
    <path
      style={{ fill: '#0072bc' }}
      d='M429.61,60.93h6.19l-3.07-7.19Zm14.57,6a3.4,3.4,0,0,1,.27,1.14,2.54,2.54,0,0,1-4.9.83l-1.87-3.76h-9.9l-1.88,3.76A2.54,2.54,0,0,1,421,68a3.18,3.18,0,0,1,.28-1.14l9.16-18.6a2.34,2.34,0,0,1,2.29-1.46A2.38,2.38,0,0,1,435,48.29Z'
      transform='translate(-35.07 -22.66)'
    />
  </svg>
)
